import React, { useState, useRef, useEffect } from "react";
import { ActionIcon, Popover } from "@mantine/core";

const ButtonWithPopoverFeedback = ({
	onClick,
	feedbackMessage = "Success!",
	duration = 1500,
	disabled = false,
	title,
	iconComponent,
	...otherProps
}) => {
	const [open, setOpen] = useState(false);
	const timeoutRef = useRef(null);

	// Cleanup timeout on unmount
	useEffect(() => {
		return () => {
			if (timeoutRef.current) {
				clearTimeout(timeoutRef.current);
			}
		};
	}, []);

	const handleClick = (event) => {
		if (onClick) {
			onClick(event);
		}

		setOpen(true);

		clearTimeout(timeoutRef.current);
		timeoutRef.current = setTimeout(() => {
			setOpen(false);
		}, duration);
	};

	const handleClose = () => {
		setOpen(false);
		clearTimeout(timeoutRef.current);
	};

	return (
		<Popover opened={open} onClose={handleClose} position="top">
			<Popover.Target>
				<ActionIcon
					variant="subtle"
					size="sm"
					disabled={disabled}
					onClick={handleClick}
					title={title}
					{...otherProps}
				>
					{iconComponent}
				</ActionIcon>
			</Popover.Target>
			<Popover.Dropdown
				style={{
					background: "#333",
					color: "#fff",
					padding: "6px 12px",
					borderRadius: 4,
					fontSize: "12px",
					whiteSpace: "nowrap",
					boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
					border: "none",
				}}
			>
				{feedbackMessage}
			</Popover.Dropdown>
		</Popover>
	);
};

export default ButtonWithPopoverFeedback;
